var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "21.016",
        viewBox: "0 0 14.711 21.016",
        width: "14.711",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          id: "Icon_material-lightbulb-outline",
          d: "M11.7,22.965a1.054,1.054,0,0,0,1.051,1.051h4.2a1.054,1.054,0,0,0,1.051-1.051V21.914H11.7ZM14.855,3a7.352,7.352,0,0,0-4.2,13.387v2.375A1.054,1.054,0,0,0,11.7,19.813h6.3a1.054,1.054,0,0,0,1.051-1.051V16.387A7.352,7.352,0,0,0,14.855,3ZM17.85,14.664l-.893.63v2.417h-4.2V15.294l-.893-.63a5.254,5.254,0,1,1,5.989,0Z",
          "data-name": "Icon material-lightbulb-outline",
          fill: "#afafaf",
          transform: "translate(-7.5 -3)",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }